import { render, staticRenderFns } from "./TopicoPdf.vue?vue&type=template&id=0e875791&scoped=true"
import script from "./TopicoPdf.vue?vue&type=script&lang=js"
export * from "./TopicoPdf.vue?vue&type=script&lang=js"
import style0 from "./TopicoPdf.vue?vue&type=style&index=0&id=0e875791&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e875791",
  null
  
)

export default component.exports